import { Tag } from "antd";
import {
  getMyProjectsThunk,
  selectProject,
} from "AppStore/Slices/ProjectSlice/ProjectSlice";
import { MyPagination } from "Components/MyPagination/MyPagination";
import { TableListPage } from "Components/TableListPage/MyTable";
import { formatDate } from "Helpers/formatDate";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

export const MyProjects = () => {
  const { total, currentPage, projectsList, isLoading } =
    useSelector(selectProject);
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const timeoutId = useRef();
  const onRowClick = (row) => {
    navigate(`/projects/${row.id}`);
  };
  const columns = [
    {
      title: "Назва",
      dataIndex: "title",
    },
    {
      title: "Статус",
      render: (_, record) => <Tag>{record.projectStatus?.status}</Tag>,
    },
    {
      title: "Створено",
      render: (_, record) => formatDate(record.createdAt),
    },
    {
      title: "Останнє оновлення",
      render: (_, record) => formatDate(record.updatedAt),
    },
  ];
  useEffect(() => {
    clearTimeout(timeoutId.current);
    if (searchValue) {
      timeoutId.current = setTimeout(() => {
        if (page === 1) {
          dispatch(getMyProjectsThunk({ searchValue }));
        } else {
          dispatch(getMyProjectsThunk({ page, searchValue }));
        }
      }, 500);
      return;
    } else {
      dispatch(getMyProjectsThunk({ page }));
    }
  }, [page, searchValue]);
  return (
    <>
      <TableListPage
        isLoading={isLoading}
        mainTitle={"Мої проекти"}
        data={projectsList}
        columns={columns}
        onRowClick={onRowClick}
        showCreateButton={false}
        setSearch={setSearchValue}
        search={searchValue}
      />

      <MyPagination
        totalItems={total}
        limit={10}
        isLoading={isLoading}
        currentPage={currentPage}
        changePage={setPage}
      />
    </>
  );
};
